import { List } from '@phosphor-icons/react';
import mesaLogo from '@mesa-labs/assets/mesa.svg';
import styles from './index.module.css';

interface MobileNavProps {
  onOpen: () => void;
}

function MobileNav({ onOpen }: MobileNavProps) {
  return (
    <div className={styles.mobileNav}>
      <img src={mesaLogo} alt="Mesa" className={styles.logo} />
      <button className={styles.menuButton} onClick={onOpen} aria-label="Open navigation">
        <List color="#ffffff" size={20} />
      </button>
    </div>
  );
}

export default MobileNav;
